if (!customElements.get('b2b-tabs')) {
  customElements.define(
    'b2b-tabs',
    class B2bTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
        if (focus) this.tabs[index].focus();
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next = null;
        if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
        if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;
        if (next !== null) {
          event.preventDefault();
          this.select(next, true);
        }
      }
    }
  );
}
